import { createSlice } from "@reduxjs/toolkit";

export const FAVORITES_STORAGE_KEY = "favorites";
const DEFAULT_FAVORITES_DATA = [];

const getHydratedFavoritesData = () => {
  if (typeof window === "undefined") {
    return DEFAULT_FAVORITES_DATA;
  }

  try {
    const storedFavorites = localStorage.getItem(FAVORITES_STORAGE_KEY);
    if (!storedFavorites) {
      return DEFAULT_FAVORITES_DATA;
    }
    const parsedFavorites = JSON.parse(storedFavorites);
    return parsedFavorites;
  } catch (error) {
    console.error("Failed to parse favorites from localStorage:", error);
    return DEFAULT_FAVORITES_DATA;
  }
};

const favoritesSlice = createSlice({
  name: "favorites",
  initialState: {
    favorites: getHydratedFavoritesData(),
  },
  reducers: {
    addToFavorites: (state, action) => {
      state.favorites.push(action.payload);
      localStorage.setItem(
        FAVORITES_STORAGE_KEY,
        JSON.stringify(state.favorites),
      );
    },
    removeFromFavorites: (state, action) => {
      const indexInState = state.favorites.findIndex(
        (item) => item === action.payload,
      );
      if (indexInState !== -1) {
        state.favorites.splice(indexInState, 1);
      }

      localStorage.setItem(
        FAVORITES_STORAGE_KEY,
        JSON.stringify(state.favorites),
      );
    },
  },
});
export const { addToFavorites, removeFromFavorites } = favoritesSlice.actions;

export default favoritesSlice;
